import { FunctionComponent } from 'react';
import styles from './SMSPhonePreview.module.scss';

interface Props {
    message: string;
    unsubscribeMessage?: string;
}

const SMSPhonePreview: FunctionComponent<Props> = ({ message, unsubscribeMessage = 'Reply STOP to unsubscribe' }) => {
    return (
        <div className={styles.phoneFrame}>
            <div className={styles.notch} />
            <div className={styles.screen}>
                {(message || unsubscribeMessage) && (
                    <div className={styles.bubble}>
                        {message && <p className={styles.messageText}>{message}</p>}
                        {unsubscribeMessage && <p className={styles.unsubscribeText}>{unsubscribeMessage}</p>}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SMSPhonePreview;
